import { useState, useEffect } from "react";
import { useTranslation } from "../i18n/LanguageContext";
import { Link } from "react-router-dom";

const CookieConsent = ({ onAccept }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("sciad_cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("sciad_cookie_consent", "accepted");
    setVisible(false);
    if (onAccept) onAccept();
  };

  const reject = () => {
    localStorage.setItem("sciad_cookie_consent", "rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4" data-testid="cookie-consent">
      <div className="max-w-4xl mx-auto p-5 rounded-2xl bg-[#131B2F] border border-white/10 shadow-2xl shadow-black/50 flex flex-col sm:flex-row items-center gap-4">
        <p className="text-sm text-slate-300 flex-1">{t("cookie_text")}</p>
        <div className="flex gap-3 shrink-0">
          <Link to="/legal/politique-confidentialite" className="px-4 py-2 text-sm text-slate-400 hover:text-white transition-colors" data-testid="cookie-more">
            {t("cookie_more")}
          </Link>
          <button onClick={reject} className="px-5 py-2 text-sm rounded-lg border border-white/20 text-slate-300 hover:bg-white/10 transition-colors" data-testid="cookie-reject">
            {t("cookie_reject")}
          </button>
          <button onClick={accept} className="px-5 py-2 text-sm rounded-lg bg-[#00CCC2] text-white font-medium hover:bg-[#00CCC2]/80 transition-colors" data-testid="cookie-accept">
            {t("cookie_accept")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
